import baseapi from "../baseAPI";
import {successMesg, errorMesg, infoMessage, warningMesg} from "./../../Pages/Toaster";

export const CampaignListAPI = async (setCampaigns, setLoading, currentPage, perpagedata, setPageCount) =>
{
    setLoading(true);

    try
    {
        const response = await baseapi.get("/api/admin/campaigns?page=" + currentPage + "&per_page=" + perpagedata);

        //console.log("Data got successfully", response.data.data.data);
        
        setCampaigns(response.data.data.data);
        setLoading(false);

        if(response.data.data.data.length > 0)
        {
            //console.log('Total count====='+response.data.data.total);
            let pagecount = Math.ceil(response.data.data.total / perpagedata);

            //console.log('page count====' + pagecount);

            setPageCount(pagecount);
        }
    }
    catch(error)
    {
        console.error("Error in user list:", error);
        setLoading(false);
    }

}

export const getAllAccountAPI = async (setAccountList, setLoading) =>
{
    setLoading(true);

    try
    {
        const response = await baseapi.get("/api/admin/accounts");

        //console.log("Data got successfully", response);
        //let userdata = ['ram', 'shyam', 'rohit'];
        setAccountList(response.data.data);
        setLoading(false);
    }
    catch(error)
    {
        console.error("Error in user list:", error);
        setLoading(false);
    }

}

export const saveCampaignDataAPI = async (params, setLoading, resetUserForm, navigate) =>{

    setLoading(true);

    try
    {
        const response = await baseapi.post("/api/admin/campaign/add", params);

        //console.log("Data saved successfully", response);
        setLoading(false);

        if(response.data.code == 200)
        {
            //console.log("Here Step 1");
            successMesg(response.data.mesg);
            resetUserForm();
            navigate('/admin/campaigns');
        }
        else if(response.data.code == 400)
        {
            //console.log("Here Step 2");
            errorMesg(response.data.mesg);    
        }

    }
    catch(error)
    {
        console.error("Error in save user:", error);
        setLoading(false);
        errorMesg(error.data.mesg);
    }
    
}

export const editCampaigndataAPI = async (campaignid, setTxtCampaignname, setTxtAccount, setTxtPromoLink, setTxtSource, setLoading) =>
{
    setLoading(true);

    try
    {
        const response = await baseapi.get("/api/admin/campaign/edit/" + campaignid);

        //console.log("Data got successfully", response.data);
        
        setTxtAccount(response.data.data.account_id);
        setTxtCampaignname(response.data.data.name);
        setTxtPromoLink(response.data.data.promo_link);
        setTxtSource(response.data.data.source);
        setLoading(false);
    }
    catch(error)
    {
        console.error("Error in user list:", error);
        setLoading(false);
    }

}

export const updateCampaignDataAPI = async (params, setLoading, navigate) =>{

    setLoading(true);

    try
    {
        const response = await baseapi.post("/api/admin/campaign/update", params);

        //console.log("Data saved successfully", response);
        setLoading(false);

        if(response.data.code == 200)
        {
            //console.log("Here Step 1");
            successMesg(response.data.mesg);
            navigate('/admin/users');
        }
        else if(response.data.code == 400)
        {
            //console.log("Here Step 2");
            errorMesg(response.data.mesg);    
        }

    }
    catch(error)
    {
        console.error("Error in save user:", error);
        setLoading(false);
        errorMesg(error.data.mesg);
    }
    
}

export const deleteCampaigndataAPI = async (deletecampaignid, setLoading, setShowModal, setIsCampaignDelete) =>
{
    setLoading(true);

    try
    {
        const response = await baseapi.get("/api/admin/campaign/delete/" + deletecampaignid);

        //console.log("Data got successfully", response.data);
        //console.log("Username: ", response.data.code);
        
        if(response.data.code == 200)
        {
            setShowModal(false);

            successMesg(response.data.mesg);

            setLoading(true);

            setIsCampaignDelete(true);
        }
        else
        {
            setShowModal(false);

            errorMesg(response.data.mesg);
        }
    }
    catch(error)
    {
        console.error("Error in user list:", error);
        //setLoading(false);
        setShowModal(false);
        //errorMesg(error);
    }
}

export const CampaignReportAPI = async (setTotalLeadCount, setAssignedLeadCount, setPendingLeadCount, setNoAnswerLeadCount, setTodayLeadCount, setCalledLeadCount, setConvertedLeadCount, setNotInterestLeadCount, setCallBackLeadCount, setNextYearLeadCount, setLoading, campaignid) =>
{
    setLoading(true);

    try
    {
        const response = await baseapi.get("/api/admin/campaign/report/" + campaignid);

        //console.log("Data got successfully", response.data.data);
        //let userdata = ['ram', 'shyam', 'rohit'];
        setTotalLeadCount(response.data.data.totalcount);
        setAssignedLeadCount(response.data.data.assignedlead);
        setPendingLeadCount(response.data.data.pendinglead);
        setNoAnswerLeadCount(response.data.data.noresponselead);
        setTodayLeadCount(response.data.data.todaylead);
        setCalledLeadCount(response.data.data.calledlead);
        setConvertedLeadCount(response.data.data.enrollledlead);
        setNotInterestLeadCount(response.data.data.notinterestedlead);
        setCallBackLeadCount(response.data.data.callbacklead);
        setNextYearLeadCount(response.data.data.nextyearlead);
        //setLeads(response.data.leads.data);
        setLoading(false);

    }
    catch(error)
    {
        console.error("Error in user list:", error);
        setLoading(false);
    }

    
}

export const CampaignLeadsAPI = async (setLeads, campaignid, currentPage, perpagedata, setPageCount, setLeadLoading) =>
{
    
    try
    {
        const response = await baseapi.get("/api/admin/campaign/lead/" + campaignid + "?page=" + currentPage + "&per_page=" + perpagedata);

        //console.log("Data got successfully", response.data.data);
        //let userdata = ['ram', 'shyam', 'rohit'];
        setLeads(response.data.leads.data);
        setLeadLoading(false);

        if(response.data.leads.data.length > 0)
        {
            //console.log('Total count====='+response.data.total);
            let pagecount = Math.ceil(response.data.total / perpagedata);

            //console.log('page count====' + pagecount);

            setPageCount(pagecount);
        }

    }
    catch(error)
    {
        console.error("Error in user list:", error);
        setLeadLoading(false);
    }

    
}


